let footerLinks = document.querySelectorAll(".footer .thb-widget-menu a");

footerLinks.forEach((link) => {
  if (link.getAttribute("href").includes("#quiz")) {
    link.classList.add("quiz");
    link.insertAdjacentHTML(
      "afterbegin",
      '<svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 18px;  display: inline-block; margin-right: 5px; margin-bottom: -4px; margin-left: -5px;"><path d="M7.26339 12.0395C7.9871 9.21561 10.2088 6.99195 13.0315 6.26543M27.0756 14.0378C27.0756 20.6861 21.6861 26.0756 15.0378 26.0756C8.38951 26.0756 3 20.6861 3 14.0378C3 7.38951 8.38951 2 15.0378 2C21.6861 2 27.0756 7.38951 27.0756 14.0378Z" stroke="currentColor" stroke-width="2px" stroke-linecap="round"></path>     <line x1="22.5902" y1="23.539" x2="32.5209" y2="33.4697" stroke="currentColor" stroke-width="2px"></line></svg>'
    );
  }
});

if (Shopify.designMode) {
  function hideColumns() {
    document.querySelectorAll(".footer-blocks .columns").forEach((e) => {
      e.setAttribute("style", "display: none");
    });
  }

  function showBlock(space) {
    hideColumns();
    document.querySelectorAll(".footer-block-" + space).forEach((e) => {
      e.setAttribute("style", "display: block");
    });
  }

  showBlock("common");
}
